import React, { useState, useEffect, useRef } from 'react';

function CariMekanik({ onSelect, onCancel }) {
  const [sopirList, setSopirList] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredSopir, setFilteredSopir] = useState([]);
  const schema = localStorage.getItem('schema');
  const inputRef = useRef(null);  

  useEffect(() => {
    if (inputRef.current) inputRef.current.focus();  

    const fetchSopir = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_BASE_URL}/utama.php?caller=mekanik&schema=${schema}`
        );
        const data = await response.json();
        const sopirArray = Array.isArray(data) ? data : [];
        setSopirList(sopirArray);
        setFilteredSopir(sopirArray);
      } catch (error) {
        console.error('Error fetching sopir:', error);
      }
    };

    fetchSopir();
  }, [schema]);

  useEffect(() => {
    const filtered = sopirList.filter((sopir) =>
      sopir.SOPIR?.toLowerCase().includes(searchTerm.toLowerCase())
    );
    setFilteredSopir(filtered);
  }, [searchTerm, sopirList]);

  const isMobile = window.innerWidth <= 480;

  return (
    <div
      style={{
        width: isMobile ? '90%' : '420px',
        margin: isMobile ? '20px auto' : '40px auto',
        padding: isMobile ? '15px' : '20px',
        border: '1px solid #ccc',
        borderRadius: '10px',
        backgroundColor: '#ffffff',
        boxShadow: '0 3px 6px rgba(0,0,0,0.1)',
        position: 'relative',
      }}
    >
      {/* Tombol batal di kanan atas */}
      <button
        onClick={onCancel}
        style={{
          position: 'absolute',
          top: '8px',
          right: '8px',
          backgroundColor: '#f44336',
          color: 'white',
          border: 'none',
          borderRadius: '5px',
          padding: isMobile ? '4px 8px' : '6px 12px',
          cursor: 'pointer',
          fontSize: isMobile ? '12px' : '14px',
        }}
      >
        ✖
      </button>

      <h2
        style={{
          textAlign: 'center',
          color: '#333',
          marginTop: isMobile ? '10px' : '0',
          marginBottom: '15px',
          fontSize: isMobile ? '16px' : '20px',
        }}
      >
        Cari Makanik
      </h2>

      <div style={{ marginBottom: '15px' }}>
        <input
          ref={inputRef}
          type="text"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          placeholder="Masukkan nama mekanik..."
          style={{
            width: '100%',
            padding: isMobile ? '6px' : '8px',
            borderRadius: '6px',
            border: '1px solid #ccc',
            fontSize: isMobile ? '13px' : '14px',
          }}
        />
      </div>

      <div
        style={{
          maxHeight: isMobile ? '240px' : '300px',
          overflowY: 'auto',
          overflowX: 'hidden',
          borderRadius: '6px',
          border: '1px solid #eee',
        }}
      >
        <table
          style={{
            width: '100%',
            borderCollapse: 'collapse',
            fontSize: isMobile ? '12.5px' : '14px',
          }}
        >
          <thead>
            <tr style={{ backgroundColor: '#f0f0f0' }}>
              <th
                style={{
                  border: '1px solid #ddd',
                  padding: isMobile ? '6px' : '8px',
                  width: '70%',
                }}
              >
                Nama Mekanik
              </th>
              <th
                style={{
                  border: '1px solid #ddd',
                  padding: isMobile ? '6px' : '8px',
                  textAlign: 'center',
                  width: '30%',
                }}
              >
                Aksi
              </th>
            </tr>
          </thead>
          <tbody>
            {filteredSopir.length > 0 ? (
              filteredSopir.map((sopir, index) => (
                <tr
                  key={index}
                  style={{
                    backgroundColor: index % 2 === 0 ? '#fff' : '#f9f9f9',
                    cursor: 'pointer',
                  }}
                  onDoubleClick={() => onSelect(sopir)}  
                >
                  <td
                    style={{
                      border: '1px solid #ddd',
                      padding: isMobile ? '5px' : '6px',
                      wordWrap: 'break-word',
                    }}
                  >
                    {sopir.SOPIR}
                  </td>
                  <td
                    style={{
                      textAlign: 'center',
                      border: '1px solid #ddd',
                      padding: isMobile ? '4px' : '6px',
                    }}
                  >
                    <button
                      onClick={() => onSelect(sopir)}
                      style={{
                        padding: isMobile ? '3px 6px' : '5px 10px',
                        backgroundColor: '#4CAF50',
                        color: 'white',
                        border: 'none',
                        borderRadius: '5px',
                        cursor: 'pointer',
                        fontSize: isMobile ? '12px' : '13px',
                      }}
                    >
                      Pilih
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td
                  colSpan="2"
                  style={{
                    textAlign: 'center',
                    padding: '10px',
                    color: '#888',
                    fontSize: isMobile ? '13px' : '14px',
                  }}
                >
                  Tidak ada data mekanik.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

    </div>
  );
}

export default CariMekanik;
